import { gql } from '@/__generated__/gql.ts';

export const CREATE_NOTIFICATIONS_QUERY = gql(`
  mutation CreateNotifications($data: CreateNotificationsInput!) {
    sendNotification(data: $data)
  }
`);
